<template>
  <button @click.prevent="trigger"  class="by-button">
    <span><slot></slot></span>
  </button>
</template>

<script>
  export default {
  
    methods:{
      trigger(e){
        this.$emit('click',e)
      }
    }
  }
</script>

<style lang="scss" scoped>
.by-button {
    font-size:18px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #004fb1;
  border: none;
  border-radius:50px;
  color: #fff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-family: DFLiHei-Bd-HK-BF, DFLiHei-Bd-HK;
  //   font-weight: $--button-font-weight;
}
</style>


// WEBPACK FOOTER //
// src/components/public/ByButton.vue